import { useAuth0 } from '@auth0/auth0-react'
import { Alert, Button } from '@ideon-api/ideon-ui'
import type { ReactNode } from 'react'

export function AuthGate({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated, loginWithRedirect, error } = useAuth0()

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center text-ideon-gray-70">
        Loading…
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex h-screen w-screen items-center justify-center p-6">
        <Alert variant="error">{error.message}</Alert>
      </div>
    )
  }

  if (!isAuthenticated) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Button
          variant="filled"
          onClick={() =>
            loginWithRedirect({
              appState: { returnTo: window.location.pathname + window.location.search },
            })
          }
        >
          Log in
        </Button>
      </div>
    )
  }

  return <>{children}</>
}
